// Template configurations for decoder pages
export const decoderTemplates = {
  '/AipDecoder': {
    pageKey: 'aip',
    title: 'aipDecoder',
    breadcrumbTitle: 'aipDecoder',
    breadcrumbItem: 'aipName',
    infoText: 'aipDecodeInfo',
    endpoint: 'cloud/v1/AIP/AIPDecode',
    defaultValue: '3900',
    fieldConfig: {
      name: 'data',
      label: 'AIP',
      placeholder: '4 Hex digits (e.g. 3900)',
      tooltipText: 'Data: AIP data to decode.',
      validation: { min: 4, max: 4 },
      lengthLabel: 'Length'
    },
    successMessage: 'aipOperationSuccess',
    failMessage: 'aipOperationFail',
    hasMatrix: true,
    metaTags: {
      title: 'Wechip - Wechip Payment Tools | AIP Decoder',
      description: 'The Application Interchange Profile (AIP) is a indicates the capabilities of the card to support specific functions in the application. data element in EMV smart cards that defines the card\'s capabilities and features for card acceptance. Learn about AIP format, usage, and its significance in EMV chip card transactions.',
      keywords: 'AIP, Application Interchange Profile, EMV Tag 82, Smart Card, Chip Card, Payment, Banking, Card Acceptance, Features, Format, Usage, Chip Card Transaction, Transaction Processing, Card Capability, Card Feature'
    }
  },
  
  '/TTQDecoder': {
    pageKey: 'ttq',
    title: 'TTQ (Tag 9F66)',
    breadcrumbTitle: 'TTQ (Tag 9F66) ',
    breadcrumbItem: 'Terminal Transaction Qualifiers',
    infoText: 'Indicates reader capabilities, requirements, and preferences to the card.',
    endpoint: 'cloud/v1/TTQ/TTQDecode',
    defaultValue: '26000000',
    fieldConfig: {
      name: 'data',
      label: 'TTQ',
      placeholder: '8 Hex Digits (e.g. 26000000)',
      tooltipText: 'Data: TTQ data to decode.',
      validation: { min: 8, max: 8 },
      lengthLabel: 'Length'
    },
    successMessage: 'ttqDecoderOperationSuccess',
    failMessage: 'ttqDecoderOperationFail',
    hasMatrix: true,
    metaTags: {
      title: 'Wechip - Wechip Payment Tools | TTQ Decoder',
      description: 'TERMINAL TRANSACTION QUALIFIERS (EMV Tag 9F66) indicates the reader capabilities, requirements, and preferences to the card during a transaction. Learn about the structure and significance of TERMINAL TRANSACTION QUALIFIERS in EMV chip card transactions, its role in conveying reader preferences to the card, and its importance in facilitating secure and efficient payment processing.',
      keywords: 'TERMINAL TRANSACTION QUALIFIERS, EMV Tag 9F66, reader capabilities, transaction requirements, reader preferences, chip card transactions, payment processing, secure transactions, transaction security'
    }
  },

  '/TvrDecoder': {
    pageKey: 'tvr',
    title: 'tvrDecoder',
    breadcrumbTitle: 'TVR (Tag 95)',
    breadcrumbItem: 'Terminal Verification Results',
    infoText: 'tvrDataInfo',
    endpoint: 'cloud/v1/TVRDecoder/TVRDecode',
    defaultValue: '0000000000',
    fieldConfig: {
      name: 'data',
      label: 'TVR',
      placeholder: '10 Hex Digits (e.g. 0000000000)',
      tooltipText: 'TVR data to decode.',
      validation: { min: 10, max: 10 },
      lengthLabel: 'length'
    },
    successMessage: 'tvrDecoderOperationSuccess',
    failMessage: 'tvrDecoderOperationFail',
    hasMatrix: true,
    metaTags: {
      title: 'Wechip - Wechip Payment Tools | {t(tvrDecoder)}',
      description: 'TERMINAL VERIFICATION RESULTS (EMV Tag 95) indicates the status of various functions from the perspective of the terminal during a transaction. Explore the structure and significance of TERMINAL VERIFICATION RESULTS in EMV chip card transactions, its role in conveying the terminal\'s assessment of transaction functions, and its importance in ensuring secure and reliable payment processing.',
      keywords: 'TERMINAL VERIFICATION RESULTS, EMV Tag 95, terminal functions, transaction status, chip card transactions, payment processing, secure transactions, transaction security'
    }
  },

  '/TermCapOperation': {
    pageKey: 'termCap',
    title: 'Terminal Capabilities Operation',
    breadcrumbTitle: 'Terminal Capabilities Operation',
    breadcrumbItem: 'Terminal Capabilities',
    infoText: 'Terminal capabilities and features operation.',
    endpoint: 'cloud/v1/TermCap/TermCapOperation',
    defaultValue: 'E0F0FF',
    fieldConfig: {
      name: 'data',
      label: 'Terminal Capabilities',
      placeholder: '6 Hex digits (e.g. E0F0FF)',
      tooltipText: 'Data: Terminal capabilities data to process.',
      validation: { min: 6, max: 6 },
      lengthLabel: 'Length'
    },
    successMessage: 'termCapOperationSuccess',
    failMessage: 'termCapOperationFail',
    hasMatrix: true,
    metaTags: {
      title: 'Wechip - Wechip Payment Tools | Terminal Capabilities',
      description: 'Terminal capabilities operation for EMV transactions.',
      keywords: 'Terminal Capabilities, EMV, Payment Processing'
    }
  },

  '/AppUsageControl': {
    pageKey: 'appUsageControl',
    title: 'appUsageControlDecoder',
    breadcrumbTitle: 'appUsageControlDecoder',
    breadcrumbItem: 'Application Usage Control',
    infoText: 'Application usage control decoder operation.',
    endpoint: 'cloud/v1/AppUsageControl/AppUsageControl',
    defaultValue: 'FF00',
    fieldConfig: {
      name: 'data',
      label: 'Application Usage Control',
      placeholder: '4 Hex Digits (e.g. FF00)',
      tooltipText: 'Data: Application usage control data to decode.',
      validation: { min: 4, max: 4 },
      lengthLabel: 'Length'
    },
    successMessage: 'appUsageControlOperationSuccess',
    failMessage: 'appUsageControlOperationFail',
    hasMatrix: true,
    metaTags: {
      title: 'Wechip - Wechip Payment Tools | Application Usage Control Decoder',
      description: 'Application Usage Control decoder for EMV transactions.',
      keywords: 'Application Usage Control, EMV, Payment Processing'
    }
  },

  '/CVMResults': {
    pageKey: 'cvmResults',
    title: 'cvmResultsDecoder',
    breadcrumbTitle: 'cvmResultsDecoder',
    breadcrumbItem: 'CVM Results',
    infoText: 'Cardholder Verification Method results decoder operation.',
    endpoint: 'cloud/v1/CVMResults/CVMResults',
    defaultValue: '000000',
    fieldConfig: {
      name: 'data',
      label: 'CVM Results',
      placeholder: '6 Hex Digits (e.g. 000000)',
      tooltipText: 'Data: CVM Results data to decode.',
      validation: { min: 6, max: 6 },
      lengthLabel: 'Length'
    },
    successMessage: 'cvmResultsOperationSuccess',
    failMessage: 'cvmResultsOperationFail',
    hasMatrix: true,
    metaTags: {
      title: 'Wechip - Wechip Payment Tools | CVM Results Decoder',
      description: 'CVM Results decoder for EMV transactions.',
      keywords: 'CVM Results, Cardholder Verification Method, EMV, Payment Processing'
    }
  },

  '/CvmDecoder': {
    pageKey: 'cvmList',
    title: 'cvmDecoder',
    breadcrumbTitle: 'cvmDecoder',
    breadcrumbItem: 'cvmDecoder',
    infoText: 'cvmListInfo',
    endpoint: 'cloud/v1/CVM/CVMDecode',
    defaultValue: '0000000000000000',
    skipInitialRequest: true,
    fieldConfig: {
      name: 'data',
      label: 'cvmList',
      placeholder: 'At Least 20 Hex Digits (e.g. 0000000000000000420142031E03)',
      tooltipText: 'Data: CVM List data to decode.',
      validation: { min: 20, max: 252 },
      lengthLabel: 'length'
    },
    successMessage: 'cvmDecoderOperationSuccess',
    failMessage: 'cvmDecoderOperationFail',
    hasMatrix: false, 
    metaTags: {
      title: 'Wechip - Wechip Payment Tools | CVM List Decoder',
      description: 'CVM List decoder for EMV transactions.',
      keywords: 'CVM List, Cardholder Verification Method, EMV Tag 8E, Payment Processing'
    }
  },

  '/CTQDecoder': {
    pageKey: 'ctq',
    title: 'ctqDecoder',
    breadcrumbTitle: 'ctqDecoder',
    breadcrumbItem: 'Card Transaction Qualifiers',
    infoText: 'Card Transaction Qualifiers decoder operation.',
    endpoint: 'cloud/v1/CTQ/CTQDecode',
    defaultValue: '3C00',
    fieldConfig: {
      name: 'data',
      label: 'CTQ',
      placeholder: '4 Hex Digits (e.g. 3C00)',
      tooltipText: 'Data: CTQ data to decode.',
      validation: { min: 4, max: 4 },
      lengthLabel: 'Length'
    },
    successMessage: 'ctqDecoderOperationSuccess',
    failMessage: 'ctqDecoderOperationFail',
    hasMatrix: true,
    metaTags: {
      title: 'Wechip - Wechip Payment Tools | CTQ Decoder',
      description: 'Card Transaction Qualifiers decoder for EMV transactions.',
      keywords: 'Card Transaction Qualifiers, CTQ, EMV, Payment Processing'
    }
  },
  
  '/Tag9F40': {
    pageKey: 'tag9F40',
    title: '9f40Decoder',
    breadcrumbTitle: '9F40 (Tag 9F40)',
    breadcrumbItem: 'Additional Terminal Capabilities - 9F40',
    infoText: 'Additional terminal capabilities decoder',
    endpoint: 'cloud/v1/Tag9F40/Tag9F40',
    defaultValue: 'E000F0E001',
    fieldConfig: {
      name: 'data',
      label: '9F40',
      placeholder: '10 Hex Digits (e.g. E000F0E001)',
      tooltipText: '9F40 data to decode.',
      validation: { min: 10, max: 10 },
      lengthLabel: 'length'
    },
    successMessage: '9f40DecoderOperationSuccess',
    failMessage: '9f40DecoderOperationFail',
    hasMatrix: true,
    metaTags: {
      title: 'Wechip - Wechip Payment Tools | {t(9f40Decoder)}',
      description: '9F40 (EMV Tag 9F40) indicates the status of various functions from the perspective of the terminal during a transaction. Explore the structure and significance of 9F40 in EMV chip card transactions, its role in conveying the terminal\'s assessment of transaction functions, and its importance in ensuring secure and reliable payment processing.',
      keywords: '9F40, EMV Tag 9F40, terminal functions, transaction status, chip card transactions, payment processing, secure transactions, transaction security'
    }
  },
};

// Get template configuration by route path
export const getTemplateConfig = (pathname) => {
  return decoderTemplates[pathname] || null;
};

// Get all available decoder paths
export const getAvailableDecoderPaths = () => {
  return Object.keys(decoderTemplates);
};
